import { render, staticRenderFns } from "./SDS-info-modal.vue?vue&type=template&id=45b94a85"
import script from "./SDS-info-modal.vue?vue&type=script&lang=js"
export * from "./SDS-info-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports